import { CommonNS } from "../../../../Common/CommonNS.js";
import { ControllerNS } from "../../Controller/ControllerNS.js";
import { VONS } from "../../VO/VONS.js";
export class ViewBoxElView {
  constructor({ view_box_el, view_box_controller }) {
    this._view_box_el = view_box_el;
    this._view_box_controller_subscription = view_box_controller.subscribe(
      (view_box_vo) => this._observeViewBoxController(view_box_vo)
    );
  }
  destroy() {
    this._view_box_controller_subscription();
  }
  _observeViewBoxController({ x, y, width, height }) {
    CommonNS.UtilNS.tryNoop(() =>
      this._view_box_el.setAttributeNS(
        null,
        "viewBox",
        `${x} ${y} ${width} ${height}`
      )
    );
  }
}
